import React, { useState } from "react";
import InfoTable from "../Tables/InfoTable";
import animetionLogo from "../../assets/utils/images/animetion_logo.gif";

const Search = ({ context, loading, error, loadPage, loadingPagination }) => {
  const [disablePrevButton, setDisablePrevButton] = useState(0);
  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) window.location.href = "/#/dashboards/journy";
  if (!context) return "...データがありません";

  const orgListData = context.searchOrg.edges.map((array) => array.node);

  const disableNextButton = !context.searchOrg.pageInfo.hasNextPage;

  return (
    <div>
      <InfoTable
        orgListData={orgListData}
        title="検索結果"
        // paginationComponent={
        //   <div
        //     style={{
        //       display: "flex",
        //       justifyContent: "center",
        //       gap: "12px",
        //       border: "1px solid #e9ecef",
        //       padding: "4px",
        //     }}
        //   >
        //     <button
        //       onClick={() => {
        //         loadPage("prev");
        //         setDisablePrevButton((prev) => prev - 1);
        //       }}
        //       disabled={disablePrevButton === 0}
        //       style={{
        //         color: !disablePrevButton ? "#545cd8" : "#545cd8",
        //         background: !disablePrevButton ? "#f8f9fa" : "#f8f9fa",
        //         border: "none",
        //         flexGrow: 1,
        //         padding: "8px 12px",
        //       }}
        //     >
        //       {loadingPagination.prev ? "loading..." : "前へ"}
        //     </button>
        //     <button
        //       onClick={() => {
        //         loadPage("next");
        //         setDisablePrevButton((prev) => prev + 1);
        //       }}
        //       disabled={disableNextButton}
        //       style={{
        //         color: !disableNextButton ? "#545cd8" : "#545cd8",
        //         background: !disableNextButton ? "#f8f9fa" : "#f8f9fa",
        //         border: "none",
        //         flexGrow: 1,
        //         padding: "8px 12px",
        //       }}
        //     >
        //       {loadingPagination.next ? "loading..." : "次へ"}
        //     </button>
        //   </div>
        // }
      />
    </div>
  );
};

export default Search;
